import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["transitionType", "transitionDuration", "pauseSeconds", "saveStatus", "segmentName"]
  static values = { url: String }

  async save() {
    this.updateStatus("Saving...")

    try {
      const csrfToken = document.querySelector("meta[name='csrf-token']")?.content

      const body = {
        segment: {
          pause_seconds: parseFloat(this.pauseSecondsTarget.value) || 0,
          transition: {
            type: this.transitionTypeTarget.value,
            duration_seconds: parseFloat(this.transitionDurationTarget.value) || 0.5
          }
        }
      }

      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
          "Accept": "application/json"
        },
        body: JSON.stringify(body)
      })

      if (response.ok) {
        this.updateStatus("Saved")
      } else {
        const data = await response.json()
        this.updateStatus(`Error: ${data.error || "Failed"}`)
      }
    } catch (error) {
      console.error("Save failed:", error)
      this.updateStatus("Save failed")
    }
  }

  async saveName() {
    if (!this.hasSegmentNameTarget) return

    const name = this.segmentNameTarget.value.trim()
    const segmentIndex = this.segmentNameTarget.dataset.segmentIndex

    try {
      const csrfToken = document.querySelector("meta[name='csrf-token']")?.content

      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
          "Accept": "application/json"
        },
        body: JSON.stringify({ segment: { name: name } })
      })

      if (response.ok && segmentIndex !== undefined) {
        // Update the timeline card name to reflect the change immediately
        const displayName = name || `Segment ${parseInt(segmentIndex) + 1}`
        const card = document.querySelector(`[data-segment-index="${segmentIndex}"]`)
        if (card) {
          const nameEl = card.querySelector("[data-segment-name]")
          if (nameEl) {
            nameEl.textContent = displayName
            nameEl.title = displayName
          }
        }
      } else if (!response.ok) {
        console.error("Failed to save segment name")
      }
    } catch (error) {
      console.error("Save name failed:", error)
    }
  }

  updateStatus(text) {
    if (this.hasSaveStatusTarget) {
      this.saveStatusTarget.textContent = text
    }
  }
}
